import * as React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

export default function TalkToUsCTA({ icon, label }) {
  return (
    <Button to="https://app.sleuth.io/account/signup/">
      {label || 'Get Started'} &thinsp;
      {icon && <Icon name={icon} size="sm" />}
    </Button>
  );
}

TalkToUsCTA.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
};
